
import styled from "styled-components";

export const QuotesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 74%;
  gap: 25px;

  @media (max-width: 768px) {
    padding: 12px 0;
    gap: 12px;
    width: 100%;
  }
`;

export const Card = styled.div`
  min-height: 135px;
  margin-bottom: 16px;
  width: 100%;
  border: 1px solid #eaf1f6;
  padding: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  // min-height: 260px; 
  

  .plan-type {
    position: absolute;
    top: -10px;
    background: var(--primary-color);
    color: #fff;
    padding: 4px 8px;
    left: 20px;
    font-size: 14px;
    z-index: 1;

    &:after {
      position: absolute;
      content: "";
      right: -26px;
      top: 0;
      border: 14px solid var(--primary-color);
      border-right-color: transparent;
    }
  }

  @media (max-width: 767px) {
    padding: 16px;
    min-height: unset;
  }
`;

export const QuoteDataWrapper = styled.div`
  flex: 1 1;
`;

export const LogoWrapper = styled(QuoteDataWrapper)`
  & img {
    margin: 30px auto;
    display: block;
    width: 160px;
    height: 50px;
    margin-left: -8px;

    @media (max-width: 1199px) {
      width: 136px;
      height: 40px;
    }
  }
`;

export const AddonsData = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  min-height: 24px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 6px;
    margin-top: 6px;
    align-items: center;
  }
`;

export const QuoteData = styled.div`
  display: flex;
  justify-content: center;
  font-size: 18px;
  gap: 8px;
  margin-top: 12px;
`;
export const AddonLabel = styled.div`
  display: inline-flex;
  align-items: center;
  background: #eefbff;
  border: 1px solid #c4f1ff;
  padding: 6px 12px;
  margin: 4px 8px 4px 0; /* spacing between chips */
  font-size: 14px;
  max-width: fit-content;

  & .name {
    color: var(--primary-color);
    margin-right: 6px;
    white-space: nowrap;
  }

  & .premium {
    color: var(--tertiary-color);
    font-weight: 500;
    white-space: nowrap;
  }

  @media (max-width: 576px) {
    font-size: 12px;
    padding: 4px 10px;
    border-radius: 16px;
  }
`;

